var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Can', {
    attrs: {
      "I": _vm.ActionEnum.CREATE,
      "a": _vm.ResourceEnum.REPORT_GROUP,
      "field": _vm.partnerId
    }
  }, [!_vm.hideButton ? _vm._t("activator", function () {
    return [_c('v-btn', {
      attrs: {
        "elevation": 0
      },
      on: {
        "click": _vm.open
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("create")) + " ")])];
  }, {
    "on": _vm.open
  }) : _vm._e()], 2), _vm.isDialogActive ? _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t('report.createReportGroup'),
      "isDialogActive": _vm.isDialogActive,
      "rightText": _vm.$t('create'),
      "loading": _vm.isLoading,
      "rightLoading": _vm.isLoading,
      "rightDisabled": !_vm.reportGroup.title,
      "supressKeyboardConfirm": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "leftClick": function leftClick($event) {
        _vm.isDialogActive = false;
      },
      "close": function close($event) {
        _vm.isDialogActive = false;
      },
      "rightClick": _vm.onRightClick
    }
  }, [_c('v-row', {
    staticClass: "pt-3",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    ref: "titleField",
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.reportGroup.title') + ' *',
      "rules": _vm.requiredRule
    },
    model: {
      value: _vm.reportGroup.title,
      callback: function callback($$v) {
        _vm.$set(_vm.reportGroup, "title", $$v);
      },
      expression: "reportGroup.title"
    }
  }), _c('v-textarea', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.reportGroup.description')
    },
    model: {
      value: _vm.reportGroup.description,
      callback: function callback($$v) {
        _vm.$set(_vm.reportGroup, "description", $$v);
      },
      expression: "reportGroup.description"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "ma-n3"
  }, [_c('v-subheader', [_vm._v(" " + _vm._s(_vm.$t("objects.reportGroup.configuration.status")) + " ")]), _c('custom-field-configuration-form', {
    staticClass: "mx-2 my-n3",
    attrs: {
      "types": _vm.ReportGroup.statusCustomFieldTypes
    },
    model: {
      value: _vm.status,
      callback: function callback($$v) {
        _vm.status = $$v;
      },
      expression: "status"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "ma-n3"
  }, [_c('v-subheader', [_vm._v(" " + _vm._s(_vm.$t("objects.reportGroup.configuration.customFields")) + " ")]), _c('custom-field-configuration-form', {
    key: 'status.map(s => s.customField.id)' + _vm.status.map(function (s) {
      return s.customField.id;
    }),
    staticClass: "mx-2 my-n3",
    attrs: {
      "omitIds": _vm.status.map(function (s) {
        return s.customField.id;
      })
    },
    model: {
      value: _vm.customFieldConfig,
      callback: function callback($$v) {
        _vm.customFieldConfig = $$v;
      },
      expression: "customFieldConfig"
    }
  })], 1)])], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }